import dayjs from 'dayjs'

function convertToMinutes(time) {
    const startOfDay = dayjs().startOf('day')
    let hours, minutes
    ;[hours, minutes] = time.split(':')
    const slotDate = startOfDay.clone().add(hours, 'hours').add(minutes, 'minutes')
    return slotDate.diff(startOfDay, 'minutes')
}

function transformDayToSchedule(day) {
    let formattedDay = []
    let from
    let to
    day.forEach((slot, index) => {
        if (!from || !to) {
            from = slot[0]
        } else if (to !== slot[0]) {
            formattedDay.push({ from: convertToMinutes(from), to: convertToMinutes(to) })
            from = slot[0]
        }
        to = slot[1]
        if (index === day.length - 1) {
            formattedDay.push({ from: convertToMinutes(from), to: convertToMinutes(to) })
        }
    })
    return formattedDay
}

export default {
    transform(data) {
        if (data === 'null') {
            return { slots: null }
        }
        data = JSON.parse(data)
        data.slots = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map((day) => transformDayToSchedule(data.slots[day]))
        return data
    },
}
